import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { Form } from 'react-bootstrap'
import { useErrorService, plans } from '@abroad/components'
import { OrgEcoIdsContext } from '../../utils/contexts'
import API from '../../utils/API'

const ProgramCheckbox = () => {
  const { companyAndEcoInfo, setCompanyAndEcoInfo } =
    useContext(OrgEcoIdsContext)
  const [isProgram, setIsProgram] = useState(
    companyAndEcoInfo?.isProgram || false,
  )
  const [isLoading, setIsLoading] = useState(false)
  const Error = useErrorService()

  useEffect(() => {
    if (companyAndEcoInfo?.isProgram) {
      setIsProgram(true)
    } else {
      setIsProgram(false)
    }
  }, [companyAndEcoInfo])

  const updateIsProgramFlag = async () => {
    setIsLoading(true)
    try {
      const { status } =
        await API.AdminAPI.entityService.updateNetworkEntityProgramData(
          'network',
          companyAndEcoInfo?._id,
          {
            isProgram: !isProgram,
            ...(!isProgram && {
              targetPlan: plans.free.code,
            }),
          },
        )
      if (status) {
        setCompanyAndEcoInfo((prev) => ({
          ...prev,
          isProgram: !isProgram,
          ...(!isProgram && {
            planCode: null,
            targetPlan: plans.free.code,
          }),
          ...(isProgram && { targetPlan: null, networkPromo: null }),
        }))
        setIsProgram(!isProgram)
        setIsLoading(false)
      }
    } catch (e) {
      Error.showError(e)
      setIsLoading(false)
    }
  }

  return (
    <div className='calender-setup-checkbox mb-3'>
      <Form.Check
        id='isProgram'
        custom={true}
        onChange={updateIsProgramFlag}
        checked={isProgram ? true : false}
        type='checkbox'
        label='Is it a program?'
        className={classNames('s6', {
          'cursor-pointer': !isLoading,
          'pointer-events-none': isLoading,
        })}
        disabled={isLoading}
      />
      {isLoading && <span className='s7'>Updating...</span>}
    </div>
  )
}

export default ProgramCheckbox
